// TrendDayChart.jsx
import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CardHeader from "../Layout/CardHeader";
import SuperInsightsModal from "../Ia/SuperInsightsModal";
import Meta from '../Layout/Meta';

const TrendDayChart = ({ item }) => {
  // Verifica se item está definido
  const safeItem = item || {};

  // Desestruturação com valores default
  const {
    Sigla = '',
    Descricao_Dashboard_Componente:  titulo = "-",
    dadosComponente = {},
    Valor_Meta = {},
    Texto_Info = "-",
    Texto_BizAI = "",
    ESG_Info = "-",
    Codigo_Transacao_Link = "",
    Titulo_Transacao_Link = ""
  } = safeItem;

  // Detecta variação negativa ou positiva
  const isNegative = dadosComponente.valor?.trim().startsWith('-');

  // Cores para condicionar negativo/positivo
  const negativeBg = '#FFE9E9';
  const negativeColor = '#DF2C2C';
  const positiveBg = '#E2FCEF';
  const positiveColor = '#18A150';

  // Estilos do "pill" (selo de variação)
  const variationStyle = {
    backgroundColor: isNegative ? negativeBg : positiveBg,
    color: isNegative ? negativeColor : positiveColor,
    borderRadius: '20px',
    padding: '4px 12px',
    fontSize: '0.9rem',
    fontWeight: '600',
    display: 'inline-block'
  };

  // Controle do modal
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const togglePopup = () => setIsPopupOpen(!isPopupOpen);
  const slugId = Sigla.trim().replace(/\s+/g, "-");

  return (
    <>
      <Card className="w-100 h-100 ">
        <CardBody className="w-100 h-100 d-flex flex-column cardbody-dash">
          {/* Título do card e ícones */}
          <CardHeader
            titulo={titulo}
            Texto_Info={Texto_Info}
            ESG_Info={ESG_Info}
            togglePopup={togglePopup}
            slugId={slugId}
            textoIA={Texto_BizAI}
            Codigo_Transacao_Link={Codigo_Transacao_Link}
            Titulo_Transacao_Link={Titulo_Transacao_Link}
          />

          {/* Se tiver metas adicionais */}
          <Meta Valor_Meta={Valor_Meta} />

          {/* Centro do card: valor principal */}

<div 
  className="flex-grow-1 d-flex flex-column align-items-center" 
  style={{ height: "100%" }} // Garante ocupar toda a altura do CardBody
>
  {/* Conteúdo Principal (centralizado no espaço vertical) */}
  <div 
    className="d-flex flex-column justify-content-center align-items-center" 
    style={{ flexGrow: 1 }}
  >
    <h1 style={{
      fontSize: '2.5rem',
      fontWeight: '600',
      color: '#3f4a68'
    }}>
      {dadosComponente.Texto}
    </h1>
  </div>

  {/* Rodapé (forçado para baixo com marginTop: 'auto') e centrado horizontalmente */}
  <div 
    className="d-flex align-items-center justify-content-center" 
    style={{ gap: 8, marginTop: 'auto' }}
  >
    <div style={variationStyle}>
      {dadosComponente.valor}
    </div>
    <span style={{ fontSize: '0.9rem', color: '#999999' }}>
      {dadosComponente.texto_valor}
    </span>
  </div>
</div>


        </CardBody>
      </Card>

      {/* Modal de Insights */}
      <SuperInsightsModal
        isOpen={isPopupOpen}
        toggle={togglePopup}
        textoIA={Texto_BizAI}
      />
    </>
  );
};

export default TrendDayChart;
